export default __webpack_public_path__ + "static/media/cyber-resilance.aa78938c.png";